import Typography from "@mui/material/Typography";
import {ReactNode} from "react";

export interface SectionTitleProps {
    children: ReactNode;
}

export default function SectionTitle({children}: Readonly<SectionTitleProps>) {
    return (
        <Typography variant={"subtitle1"} fontWeight={"bold"} color={"primary"}>{children}</Typography>
    );
}